import React from 'react';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import "./c42_formstack.scss";
// @ts-ignore
import InnerHTML from 'dangerously-set-html-content';


interface C42FormstackData {
    content: string;
}

class C42Formstack extends TemplateComponent<C42FormstackData> {

    componentRender(data: C42FormstackData): React.ReactElement {
        return (
            <div className="c42-formstack auto-margins" >
                <InnerHTML html={data.content} />
            </div>
        );
    }
}

export default C42Formstack;